import { render } from "./TheaterProfile.vue?vue&type=template&id=23283737"
import script from "./TheaterProfile.vue?vue&type=script&lang=js"
export * from "./TheaterProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__